import { Separator as SeparatorPrimitive } from "@base-ui/react/separator";
import type React from "react";
import { cn } from "@/lib/utils";

export function Separator({
  className,
  orientation = "horizontal",
  ...props
}: SeparatorPrimitive.Props): React.ReactElement {
  return (
    <SeparatorPrimitive
      className={cn(
        // Vertical separators stretch to fill their container's cross axis by
        // default. An explicit height (e.g. site-header's `h-4`) wins naturally
        // — align-self:stretch is ignored when the item has a definite cross-size
        // — so no guard selector is needed (the previous :not-[[class^='h-']]
        // attempt never matched: the merged class string always started with
        // `shrink-0`, making both substring predicates a no-op).
        "shrink-0 bg-border data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:w-px data-[orientation=vertical]:self-stretch",
        className,
      )}
      data-slot="separator"
      orientation={orientation}
      {...props}
    />
  );
}

export { SeparatorPrimitive };
